import React, { useState, useEffect } from 'react';
import { withRouter, useHistory, useParams } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { Button, Form } from 'react-bootstrap';
import Slider from '../../Services/Slider';
import Alert from '../../Services/Alert';
import { prepareBannerImage, aspectWarning, BANNER_HINT } from '../../Services/BannerImage';
import BannerPreview from './BannerPreview';

export const SliderEdit = (props) => {
    const history = useHistory();
    const { id } = useParams();
    const [currentImage, setCurrentImage] = useState('');
    const [preview, setPreview] = useState('');
    const [warning, setWarning] = useState('');
    const [bannerId, setBannerId] = useState('');
    const [saving, setSaving] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset } = useForm({ mode: "onChange", defaultValues: { title: "", status: "1", sort_order: 0 } });

    useEffect(() => {
        Slider.edit(id).then((res) => res.data).then(res => {
            if (res.status && typeof res.data !== 'undefined') {
                reset({
                    title: res.data.title,
                    status: res.data.status ? "1" : "0",
                    sort_order: res.data.sort_order || 0,
                });
                setCurrentImage(res.data.image_url);
                setBannerId(res.data._id);
            } else {
                Alert.error(res.message);
            }
        }).catch(error => {
            Alert.error(error.message);
        });
    }, []);

    const imageField = register("image");
    const onPick = (e) => {
        const file = e.target.files && e.target.files[0];
        setWarning('');
        if (!file) { setPreview(''); return; }
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => setWarning(aspectWarning(img.naturalWidth, img.naturalHeight));
        img.src = url;
        setPreview(url);
    };

    const onUpdate = async (data) => {
        setSaving(true);
        try {
            const payload = {
                id: bannerId,
                title: data.title,
                status: data.status,
                sort_order: parseInt(data.sort_order, 10) || 0,
                image: '',          // '' = keep the current picture
                extension: '',
            };
            if (data.image && data.image.length > 0) {
                const prepared = await prepareBannerImage(data.image[0]);
                payload.image = prepared.image;
                payload.extension = prepared.extension;
            }
            const res = (await Slider.update(payload)).data;
            if (res.status) {
                Alert.success('Banner updated.');
                history.push('/sliders');
            } else {
                Alert.error(res.message);
            }
        } catch (error) {
            Alert.error(error.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <section className="main-content slideradd_main_sec">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title mb-4">Edit Banner</h4>
                                        <Form className="needs-validation" noValidate onSubmit={handleSubmit(onUpdate)}>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3" controlId="title">
                                                        <Form.Label>Title</Form.Label>
                                                        <Form.Control type="text" placeholder="For your reference (not shown in the app)" {...register("title", { required: true, maxLength: 80 })} />
                                                        <div className="error">
                                                            {errors.title?.type === 'required' && "Title is required"}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3" controlId="formImage">
                                                        <Form.Label>Replace image (optional)</Form.Label>
                                                        <Form.Control type="file" accept="image/jpeg,image/png,image/webp" className="form-control"
                                                            {...imageField} onChange={(e) => { imageField.onChange(e); onPick(e); }} />
                                                        <div className="text-muted small mt-1">{BANNER_HINT}</div>
                                                    </Form.Group>
                                                    {preview
                                                        ? <BannerPreview src={preview} label="New image, as it will look in the app" />
                                                        : <BannerPreview src={currentImage} label="Current image, as it looks in the app" />}
                                                    {warning && <div className="text-warning small mb-3">{warning}</div>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <Form.Group className="mb-3" controlId="formOrder">
                                                        <Form.Label>Order</Form.Label>
                                                        <Form.Control type="number" min="0" step="1" className="form-control" {...register("sort_order", { required: true, min: 0 })} />
                                                        <div className="text-muted small mt-1">Lower numbers show first.</div>
                                                        <div className="error">
                                                            {errors.sort_order && "Enter 0 or a positive number"}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Status</Form.Label>
                                                        <div className="col-lg-12">
                                                            <Form.Check inline label="Active (shown in the app)" value="1" id="active-status" type="radio" {...register("status", { required: true })} />
                                                            <Form.Check inline label="Inactive (hidden)" value="0" id="inactive-status" type="radio" {...register("status", { required: true })} />
                                                            <div className="error">
                                                                {errors.status?.type === 'required' && "Status is required"}
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className="btn-submit">
                                                <Button className="btn btn-primary w-md" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save Changes'}</Button>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default withRouter(SliderEdit);
